import {
  ConsentStatus,
  debug as _debug,
  Rgb
} from '@schibsted-nmp/advertising-shared';

export const debugLabel = 'Consent';
export const debug = _debug.withLabel(debugLabel, Rgb.teal, Rgb.mint);

const CONSENT_TIMEOUT_IN_MS = 10000; // 10 seconds
const DEFAULT_CONSENT_STATUS = ConsentStatus.Rejected;

export function subscribeToConsent(cb: (consentValue: boolean) => void): void {
  if (typeof window === 'undefined') return;
  window._tcf_?.isConsentedToAll(cb);
}

export function getConsentSync(): boolean | null {
  if (typeof window === 'undefined') return null;
  return window._tcf_?.getConsentedToAllSync() ?? null;
}

export async function waitForConsent() {
  try {
    const consentValueSync = getConsentSync();

    if (consentValueSync !== null) {
      const consentStatus = consentValueSync
        ? ConsentStatus.Accepted
        : DEFAULT_CONSENT_STATUS;

      debug.withSublabel(debugLabel, 'sync')
        .message`User has ${consentStatus}`().info();

      return consentStatus;
    }

    const debugAsync = debug.withSublabel(debugLabel, 'async');
    const { promise, resolve, reject } = Promise.withResolvers<ConsentStatus>();

    let cancelled = false;

    const timer = setTimeout(() => {
      cancelled = true;
      reject(new Error(`Consent timeout after ${CONSENT_TIMEOUT_IN_MS} ms`));
    }, CONSENT_TIMEOUT_IN_MS);

    subscribeToConsent((consentValueAsync) => {
      if (cancelled) return;

      clearTimeout(timer);

      const consentStatus = consentValueAsync
        ? ConsentStatus.Accepted
        : DEFAULT_CONSENT_STATUS;

      debugAsync.message`User has ${consentStatus}`().info();
      resolve(consentStatus);
    });

    return await promise;
  } catch (error) {
    debug.message`Failed getting consent status, defaulting to ${DEFAULT_CONSENT_STATUS}`(
      error
    ).error();

    return DEFAULT_CONSENT_STATUS;
  }
}
